import React from "react";
import ModalDialog, { ModalFooter, ModalHeader } from "@atlaskit/modal-dialog";
import Button from "@atlaskit/button/standard-button";
import { GenericConfirmationModal } from "./GenericConfirmationModal";
import { getBaseConfig, isSocialMobileApp } from "../../Utils";
import { useSelector } from "react-redux";
import { FEATURE_CUSTOM_REDUX } from "../../constant";
import { useDevice } from "../../welcome-dashboard/Utils";
import { Translate } from "../../../webjam/language";
import Dialog from "../../../base/ui/components/web/Dialog";
import { ct } from "../../constant-Utils";


const MyRoomsModal = (props) => {
  const {
    myRoomList,
    joinFromMyRooms,
    handleState,
    title = ct("Translate.typography.myRooms")
  } = props;

  const { isMobile } = useDevice();

  return (
    <Dialog
      disableAutoHideOnSubmit={true}
      disableBackdropClose={true}
      hideCloseButton={true}
      onCancel={() => handleState({
        isViewMyRoomsModal: false,
        isMyRoomList: false,
        isOtherRoomList: false,
      })}
      cancel={{ translationKey: ct("Translate.buttonTitle.closeSmall") }}
      ok={{ hidden: true }}
      titleKey={title}
      rtaClassName="rooms-listing-wrapper"
      testId="media-files-popup"
    >
      <div className={`media-files ${isMobile ? 'scroll-rooms-list' : ''}`} >
        {myRoomList.map((room, index) => {
          return (
            <div className="list-item-outer" key={index}>
              <li
                className="dd-list-item d-flex"
                style={{ alignItems: "center" }}
                title={room.groupName}
                onClick={(e) => {
                  e.preventDefault();
                  joinFromMyRooms(room?.groupName);
                }}
              >
                <i className="fa fa-video-camera mr-4" aria-hidden="true"></i>
                {room.groupName}
              </li>
            </div>
          );
        })}
      </div>
    </Dialog>
  );
};

export default MyRoomsModal;

export const JoinRoomConfirmation = (props) => {
  const { userLoginData } = useSelector((store) => store[FEATURE_CUSTOM_REDUX]);
  const {
    roomName,
    handleState,
    title = ct("Translate.typography.myRooms"),
    content = `${ct("Translate.messages.joinRoom")} ${roomName}?`,
  } = props;
  return (
    <GenericConfirmationModal
      title={title}
      content={content}
      onSuccess={() => {
        handleState({ isJoiningAnotherRoom: false });
        if (isSocialMobileApp() || userLoginData?.user?.is_app) {
          window.location.href = window.location.origin + "/" + roomName;
        } else {
          window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/" + roomName;
        }
      }}
      onCancel={() =>
        handleState({
          isJoiningAnotherRoom: false,
          isMyRoomList: false,
          isOtherRoomList: false,
        })
      }
    />
  );
};
